import React, { Fragment } from "react";
import styles from "./Framing.module.css";
import Header from "../../Components/Layout/Header";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import physical from "../../Assets/Artwork.webp";
import digital from "../../Assets/Upload from PC.webp";
import { Link } from "react-router-dom";
import Footer from "../../Components/Layout/Footer";
import ShinyText from "../../Components/UI/ShinyText";
import BorderGlow from "../../Components/UI/BorderGlow";
const Framing = () => {
  return (
    <Fragment>
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mb: 50,
        }}
      >
        <Typography
          variant="h3"
          sx={{ mt: 6, textAlign: "center" }}
          component="h2"
        >
          What do you want to frame?
        </Typography>
        <Typography sx={{ color: "#949494", mt: 1 }} variant="h6">
          Select one option below
        </Typography>
        <Typography sx={{ color: "#949494", mb: 4, zIndex: 100 }} variant="h6">
          Or view our{" "}
          <Link to="/instore-framing" className={styles.link}>
            <ShinyText
              text=" Instore Framing"
              speed={4}
              delay={0}
              color="#949494"
              shineColor="#863a18"
              spread={200}
              direction="left"
              yoyo={false}
              pauseOnHover={false}
              disabled={false}
            />
          </Link>{" "}
          option
        </Typography>
        <Grid
          container
          sx={{ justifyContent: "space-between", py: 2 }}
          spacing={10}
        >
          <Grid item xs={12} md={6} sx={{ justifyContent: "space-between" }}>
            <Link
              to={"/measure"}
              onClick={() => localStorage.setItem("framingMode", "frame")}
            >
              <BorderGlow
                edgeSensitivity={1}
                // glowColor="#863a18"
                backgroundColor="white"
                borderRadius={28}
                glowRadius={80}
                glowIntensity={10}
                coneSpread={25}
                animated={true}
                colors={["#ffffff", "#ffffff", "#ffffff"]}
              >
                <Box
                  sx={{
                    padding: "2em",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={physical}
                    alt="Physical Artwork"
                    className={styles["card-image"]}
                  />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bolder" }}
                    component="h1"
                  >
                    Physical Artwork
                  </Typography>
                  <Typography
                    sx={{ color: "#949494", px: 7, pt: 3 }}
                    variant="subtitle1"
                  >
                    eg. Poster, Original Artworks, Certificates, Prints, Limited
                    Edition Prints and more <br />
                    *Not suitable for 3D Objects
                  </Typography>
                </Box>
              </BorderGlow>
              {/* <Card
                sx={{
                  backgroundColor: "transparent",
                  // border: "1px solid #b4b4b4",
                  boxShadow: "-3px 5px 18px #888888",
                  cursor: "pointer",
                  borderRadius: "40px",
                  height: "100%",
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    py: 5,
                  }}
                >
                  <img
                    src={physical}
                    alt="Physical Artwork"
                    className={styles["card-image"]}
                  />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bolder" }}
                    component="h1"
                  >
                    Physical Artwork
                  </Typography>
                  <Typography
                    sx={{ color: "#949494", px: 7, pt: 3 }}
                    variant="subtitle1"
                  >
                    eg. Poster, Original Artworks, Certificates, Prints, Limited
                    Edition Prints and more <br />
                    *Not suitable for 3D Objects
                  </Typography>
                </CardContent>
              </Card> */}
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Link
              to={"/upload"}
              onClick={() => localStorage.setItem("framingMode", "user")}
            >
              <BorderGlow
                edgeSensitivity={1}
                glowColor="#ffffff"
                backgroundColor="white"
                borderRadius={28}
                glowRadius={80}
                glowIntensity={10}
                coneSpread={25}
                animated={true}
                colors={["#ffffff", "#ffffff", "#ffffff"]}
              >
                <Box
                  sx={{
                    padding: "2em",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={digital}
                    alt="Digital"
                    className={styles["card-image"]}
                  />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bolder" }}
                    component="h1"
                  >
                    Digital Image
                  </Typography>
                  <Typography
                    sx={{ color: "#949494", px: 7, pt: 3 }}
                    variant="subtitle1"
                  >
                    Upload your photos for us to print and frame. <br />
                    eg. NFTs, Family Photos, Personal Photos and more
                  </Typography>
                </Box>
              </BorderGlow>
              {/* <Card
                sx={{
                  backgroundColor: "transparent",
                  // border: "1px solid #b4b4b4",
                  boxShadow: "-3px 5px 18px #888888",
                  cursor: "pointer",
                  borderRadius: "40px",
                  height: "100%",
                  py: 5,
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={digital}
                    alt="Digital"
                    className={styles["card-image"]}
                  />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bolder" }}
                    component="h1"
                  >
                    Digital Image
                  </Typography>
                  <Typography
                    sx={{ color: "#949494", px: 7, pt: 3 }}
                    variant="subtitle1"
                  >
                    Upload your photos for us to print and frame. <br />
                    eg. NFTs, Family Photos, Personal Photos and more
                  </Typography>
                </CardContent>
              </Card> */}
            </Link>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default Framing;
